import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {NewGen0OrdersContent} from './NewGen0OrdersContent';
import reportPayload from './reportPayload';

export const NewGen0OrdersReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'New Generation 0 Orders')}
      description={tt(
        'description',
        'Orders from new Clients or Coaches on your team, this month.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={NewGen0OrdersContent}
    />
  );
};

export default withHOC(
  withTranslation('report.newGen0Orders'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(NewGen0OrdersReport);
